import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
//import RecentUsedTable from "../../Components/Owners/RecentUsedTable";
// import Table from "../../Components/RecentUsed/Table";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import EditOwnerModel from "../../Components/Owners/EditOwnerModel";
import WhitelabelSettingsModel from "../../Components/Owners/WhitelabelSettingsModel";
import ViewDetailModel from "../../Components/Owners/ViewDetail";
import AddCharges from "../../Components/Owners/AddCharges";
import UploadRentAgreement from "../../Components/Owners/UploadRentAgreement";
import UploadLogo from "../../Components/Owners/UploadLogo";
import RecentUsedTable from "../../Components/Owners/RecentUsedTable";
import EditReminder from "../../Components/Owners/EditReminder";
import ViewDetailStaff from "../../Components/Owners/LastLoginStaff";
import { useParams } from "react-router-dom";
import DownloadPV from "../../Components/Owners/DownloadPV";
import UploadLeads from "../../Components/Owners/UploadLeads";
import ActivityLogsModal from "../../Components/ActiveLogs/ActivityLogsModal";
import SideModal from "../../Components/SideModal";
// import ViewDetailStaff from "../../Components/AdminStaff/ViewDetailStaff";
// import Setting from "./Setting";
// import ClientConfig from "./ClientConfig";

const RecentUsed = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const { id } = useParams();
  const [showLogs, setShowLogs] = useState(false);
  const [activityLogs, setActivityLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [fetchData, setFetchData] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("mobile");
  const [editReminder, setEditReminder] = useState(false);
  // const [setting, setSetting] = useState(false);
  // const [client, setClient] = useState(false);
  const [uploadLogo, setUploadLogo] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [downloadPv, setDownloadPv] = useState(false);
  const [uploadLeads, setUploadLeads] = useState(false);
  const [type, setType] = useState(1);
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(360, "days").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD"),
  );
  const { t, i18n } = useTranslation();
  const [viewDetailStaff, setViewDetailStaff] = useState(false);
  const [rentAgreement, setRentAgreement] = useState(false);

  const initialValues = {
    name: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(360, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const body = new FormData();
    body.append("filterType", filter);
    body.append("filterValue", filterValue);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("type", type);
    return await axios.post(`${Config.apiUrl}/getowners`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getOwnersSuccess = (res) => {
    if (res.data.status == "NOK" || res.data.data == false) {
      error = true;
    } else setFetchData(res.data.data);
  };

  const getOwnersError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getOwnersMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getOwnersSuccess,
    onError: getOwnersError,
  });
  console.log("hello", user);
  // console.log (fetchData);
  // console.log (error);
  // console.log (isLoading);

  useEffect(() => {
    const handler = setTimeout(() => {
      getOwnersMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getOwnersMutate();
  };
  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);
  };

  // --------Upload logo---------
  const uploadLogoFunction = async (values) => {
    const formData = new FormData();
    formData.append("clientId", values.id);
    formData.append("logo", values.ownerLogoImage);

    return await axios.post(`${Config.apiUrl}/uploadlogo`, formData, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "multipart/form-data",
      },
    });
  };

  const onUploadLogoSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Logo uploaded successfully!");
      setFetchData((prevData) =>
        prevData.map((owner) =>
          owner.id === selectedData.id
            ? { ...owner, logoPath: data.data.logoPath }
            : owner,
        ),
      );
    } else {
      toast.error(data?.data?.msg || "An error occurred.");
    }
    setUploadLogo(false);
    setSelectedData("");
  };

  const onUploadLogoError = (error) => {
    toast.error(error?.response?.data?.msg || "An error occurred.");
    setUploadLogo(false);
  };
  const { isLoading: uploadLogoLoading, mutate: uploadLogoMutate } =
    useMutation(uploadLogoFunction, {
      onSuccess: onUploadLogoSuccess,
      onError: onUploadLogoError,
    });

  //------------Edit Reminder---------------
  const EditReminderFunction = async (values) => {
    const body = new FormData();
    body.append("id", selectedData.id);
    body.append("canDoStaffEkyc", values.canDoStaffEkyc);
    body.append("canDoTenantEkyc", values.canDoTenantEkyc);
    body.append("tenantAttendanceEnabled", values.tenantAttendanceEnabled);
    body.append("canTenantRequestRoom", values.canTenantRequestRoom);
    body.append("canPayLandlord", values.canPayLandlord);
    body.append("canSendRentReminderToAll", values.canSendRentReminderToAll);
    body.append("gstNo", values.gstNo);

    return await axios.post(`${Config.apiUrl}/editclientreminder`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const onEditReminderSuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");
      getOwnersMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occurred");
    }
    setSelectedData("");
    setEditReminder(false);
    setFetchData(data?.data?.data);
  };
  const onEditReminderError = (data) => {
    setSelectedData("");
    setEditReminder(false);
    toast.error(data?.response?.data?.msg || "An Error Occurred");
  };
  const { isLoading: editReminderLoading, mutate: editReminderMutate } =
    useMutation(EditReminderFunction, {
      onSuccess: onEditReminderSuccess,
      onError: onEditReminderError,
    });

  // ---Download PV--------
  const DownloadPv = async (values) => {
    const body = new FormData();
    body.append("clientId", values.clientId);

    return await axios.post(
      `${Config.apiUrl}/downloadpoliceverification`,
      body,
      {
        headers: {
          authorization: "Bearer " + user.token,
        },
        responseType: "blob",
      },
    );
  };

  const onDownloadPvSuccess = (response) => {
    try {
      const blob = new Blob([response.data]);

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      link.download = "PoliceVerification.csv";

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);

      toast.success("Police Verification downloaded");
    } catch (err) {
      toast.error("File download failed");
    }

    setSelectedData("");
    setDownloadPv(false);
  };

  const onDownloadPvError = (error) => {
    toast.error("Download failed");
    setSelectedData("");
    setDownloadPv(false);
  };

  const { isLoading: downloadPvLoading, mutate: downloadPvMutate } =
    useMutation(DownloadPv, {
      onSuccess: onDownloadPvSuccess,
      onError: onDownloadPvError,
    });

  //---Upload Rent Agreement---
  const UploadRentAgreementFunction = async (values) => {
    const body = new FormData();
    body.append("clientId", values.id);
    body.append("createRentAgreement", values.createRentAgreement);
    if (values.rentAgreement) {
      body.append("rentAgreement", values.rentAgreement);
    }
    body.append("ownerSignatureImage", values.ownerSignatureImage);
    return await axios.post(`${Config.apiUrl}/addrentagreementbyclient`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onUploadRentSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Success");
      getOwnersMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setRentAgreement(false);
  };

  const onUploadRentError = (data) => {
    setRentAgreement(false);
    setSelectedData("");
    toast.error(data?.response?.data?.msg);
  };

  const { isLoading: documentUploadLoading, mutate: rentUploadMutate } =
    useMutation(UploadRentAgreementFunction, {
      onSuccess: onUploadRentSuccess,
      onError: onUploadRentError,
    });

  // --------Upload logo---------
  const uploadLeadsFunction = async (values) => {
    const formData = new FormData();
    formData.append("clientId", selectedData.id);

    formData.append("fileName", values[0]);

    return await axios.post(`${Config.apiUrl}/uploadleads`, formData, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "multipart/form-data",
      },
    });
  };

  const onUploadLeadsSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Leads uploaded successfully!");
      setFetchData((prevData) =>
        prevData.map((owner) =>
          owner.id === selectedData.id
            ? { ...owner, logoPath: data.data.logoPath }
            : owner,
        ),
      );
    } else {
      toast.error(data?.data?.msg || "An error occurred.");
    }
    setUploadLeads(false);
    setSelectedData("");
  };

  const onUploadLeadsError = (error) => {
    toast.error(error?.response?.data?.msg || "An error occurred.");
    setUploadLeads(false);
  };

  const { isLoading: uploadLeadsLoading, mutate: uploadLeadsMutate } =
    useMutation(uploadLeadsFunction, {
      onSuccess: onUploadLeadsSuccess,
      onError: onUploadLeadsError,
    });


  //----------------Active Logs--------------------------------
  const openLogs = async (item) => {
    try {
      setLogsLoading(true);

      const body = new FormData();

      body.append("clientId", item.id);
      body.append(
        "startDate",
        moment().subtract(15, "days").format("YYYY-MM-DD")
      );
      body.append(
        "endDate",
        moment().format("YYYY-MM-DD")
      );
      body.append("filterType", "mobile");
      body.append("filterValue", "");

      const response = await axios.post(
        `${Config.apiUrl}/getactivitylogs`,
        body,
        {
          headers: {
            authorization: "Bearer " + user.token,
            "Content-Type":
              "application/x-www-form-urlencoded; charset=UTF-8",
          },
        }
      );

      const logs = Array.isArray(response?.data?.data)
        ? response.data.data
        : response?.data?.data
          ? [response.data.data]
          : [];

      setActivityLogs(logs);

      // Let React finish updating the logs before opening the drawer
      requestAnimationFrame(() => {
        setShowLogs(true);
      });
    } catch (error) {
      console.error("Activity logs error:", error);

      setActivityLogs([]);

      requestAnimationFrame(() => {
        setShowLogs(true);
      });

      toast.error(
        error?.response?.data?.msg || "Failed to load activity logs"
      );
    } finally {
      setLogsLoading(false);
    }
  };

  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        {/* <Page> */}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{t("Owners")}</Title>
              <Underline />
            </div>
          </div>

          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              setFilter={setFilter}
              setFilterValue={setFilterValue}
              ChangeHandler={ChangeHandler}
              filterValue={filterValue}
              filter={filter}
              user={user}
              // setIsEditLeadVisible={setIsEditLeadVisible}
              t={t}
            />
          </div>

          {editReminder && (
            <EditReminder
              editReminderMutate={editReminderMutate}
              editReminderLoading={editReminderLoading}
              setEditReminder={setEditReminder}
              data={data?.data}
              selectedData={selectedData}
            />
          )}

          {uploadLogo && (
            <UploadLogo
              uploadLogoMutate={uploadLogoMutate}
              uploadLogoLoading={uploadLogoLoading}
              setUploadLogo={setUploadLogo}
              selectedData={selectedData}
              data={data?.data}
            />
          )}

          {uploadLeads && (
            <UploadLeads
              uploadLeadsMutate={uploadLeadsMutate}
              uploadLeadsLoading={uploadLeadsLoading}
              setUploadLeads={setUploadLeads}
              selectedData={selectedData}
              data={data?.data}
            />
          )}
          {viewDetail && (
            <ViewDetailModel
              setViewDetail={setViewDetail}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              setUploadLogo={setUploadLogo}
            />
          )}

          {viewDetailStaff && (
            <ViewDetailStaff
              setViewDetailStaff={setViewDetailStaff}
              selectedData={selectedData}
            />
          )}

          {downloadPv && (
            <DownloadPV
              setDownloadPv={setDownloadPv}
              selectedData={selectedData}
              downloadPvLoading={downloadPvLoading}
              downloadPvMutate={downloadPvMutate}
            />
          )}

          {rentAgreement && (
            <UploadRentAgreement
              setRentAgreement={setRentAgreement}
              selectedData={selectedData}
              documentUploadLoading={documentUploadLoading}
              rentUploadMutate={rentUploadMutate}
            />
          )}

          <SideModal
            isOpen={showLogs}
            onClose={() => {
              setShowLogs(false);
              setActivityLogs([]);
            }}
          >
            <ActivityLogsModal
              isOpen={showLogs}
              onClose={() => {
                setShowLogs(false);
                setActivityLogs([]);
              }}
              logs={activityLogs}
              loading={logsLoading}
            />
          </SideModal>

          {!error && !isLoading && data && (
            <TableWrapper>
              <RecentUsedTable
                apiData={fetchData || []}
                openLogs={openLogs}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setEditReminder={setEditReminder}
                setViewDetail={setViewDetail}
                setDownloadPv={setDownloadPv}
                // setSetting={setSetting}
                // setClient={setClient}
                userType={user.userType}
                userId={user.userId}
                setUploadLogo={setUploadLogo}
                setViewDetailStaff={setViewDetailStaff}
                setRentAgreement={setRentAgreement}
                setUploadLeads={setUploadLeads}
              />
              {(error || data?.data?.msg == "No data found") && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  user,
  filter,
  setFilter,
  setFilterValue,
  filterValue,
  ChangeHandler,
  t,
}) => {
  const today = moment().format("YYYY-MM-DD");
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form className="w-full">
        <FilterContainer>
          <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
            <div className="flex items-end gap-2">
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="startDate"
                    id="startDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup className="max-w-[130px]">
                <Label htmlFor="endDate">{t("End_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="endDate"
                    id="endDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
            </div>
            <ApplyBtn disabled={InitialLoading} type="submit">
              {t("Date_filter")}
            </ApplyBtn>
          </div>

          <div className="flex gap-4 items-end">
            {filter !== "status" && filter !== "paymentMode" ? (
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="filterVal">{""}</Label>
                <Field
                  className="border border-slate-300 rounded-md px-4 focus:ring-1 focus:ring-primary-color focus:border-primary-color py-2 ml-1"
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  inputMode={filter === "mobile" || filter === "id" ? "numeric" : "text"}
                  // maxLength={filter === "mobile" ? "10"  : filter === "id" ? 8 : undefined}
                  maxLength={filter === "mobile" ? 10 : undefined}
                  pattern={filter === "mobile" ? "[0-9]*" : undefined}
                  value={filterValue}
                  onChange={(e) => {
                    if (filter === "mobile" || filter === "id") {
                      const value = e.target.value;
                      // Restrict input to digits only, up to 10 characters
                      if (/^\d{0,10}$/.test(value)) {
                        ChangeHandler(e);
                      }
                    } else {
                      ChangeHandler(e);
                    }
                  }}
                // onChange={(e) => {
                //   const value = e.target.value;

                //   if (filter === "mobile") {
                //     if (/^\d{0,10}$/.test(value)) {
                //       ChangeHandler(e);
                //     }
                //   } else if (filter === "id") {
                //     // Allow digits and commas
                //     if (/^[\d,]*$/.test(value)) {
                //       ChangeHandler(e);
                //     }
                //   } else {
                //     ChangeHandler(e);
                //   }
                // }}
                />
              </InputGroup>
            ) : filter === "status" ? (
              <InputGroup
                className="min-w-[120px]"
                style={{ flexBasis: "content" }}
              >
                <Label htmlFor="filter">{t("Select")}</Label>
                <Select
                  autoComplete="off"
                  className="px-2 bg-transparent text-sm border-none"
                  style={{ height: "40px" }}
                  value={filterValue}
                  onChange={ChangeHandler}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    {t("Select Status")}
                  </MenuItem>
                  <MenuItem value="3">{t("Active")}</MenuItem>
                  <MenuItem value="4">{t("Enrolled")}</MenuItem>
                  <MenuItem value="5">{t("Defaulter")}</MenuItem>
                </Select>
              </InputGroup>
            ) : null}

            <InputGroup
              // className="min-w-[120px]"
              style={{ flexBasis: "content" }}
            >
              <Label htmlFor="filter">{t("Search By")}</Label>

              <Select
                autoComplete="off"
                className="w-24 px-2 bg-transparent text-sm border-none"
                style={{ height: "40px" }}
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                  setFilterValue("");
                }}
              >
                <MenuItem value="mobile">Phone</MenuItem>
                <MenuItem value="name">Name</MenuItem>
                <MenuItem value="id">Client Id</MenuItem>
                <MenuItem value="status">Status</MenuItem>
                {user.userType !== Config.userType.OPERATION && (
                  <MenuItem value="city">City</MenuItem>
                )}
              </Select>
            </InputGroup>
          </div>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;

export default RecentUsed;
